import { addToCart } from '@/libs/stores/cart';
import { computedCart } from '@/libs/stores/cart';
import { useStore } from '@nanostores/react';
import { Button } from '../ui/button';
export interface AddToCartProps {
  cartItem: any;
  type: string;
}

export default function AddToCart({ cartItem, type }: AddToCartProps) {
  const cart = useStore(computedCart);
  const relevantItem = cart.find((item) => item.cartItem.id === cartItem.id);
  console.log(relevantItem, 'relevantItem');
  const canAddMore = ['package', 'membership'].includes(relevantItem?.type)
    ? false
    : true;
  return (
    <>
      <div className="flex flex-col mt-4 space-y-2">
        <Button
          disabled={!canAddMore}
          onClick={() => {
            addToCart(cartItem, type);
          }}
        >
          {' '}
          Add to cart
        </Button>

        {relevantItem && (
          <div>
            {['package', 'membership'].includes(relevantItem?.type)
              ? 'Max '
              : ''}
            {relevantItem.quantity} in cart.
          </div>
        )}
      </div>
      {relevantItem?.quantity && (
        <a
          href="/store/checkout"
          className="mt-2 items-center text-sm group active:bg-gray-100 active:text-gray-900/60 active:transition-none border font-medium inline-flex justify-between outline-offset-2 px-4 py-1.5 gap-12 transition w-full bg-white dark:bg-gray-800 hover:bg-gray-50 text-black dark:text-white rounded-lg"
        >
          Checkout Now <span>&rarr;</span>
        </a>
      )}
    </>
  );
}
